import { FLOWCODE_MARKETING_BASE_URL } from '@dtx-company/true-common/src/constants/routes'
import { PlanLabel, PlanTileType } from './types'
import { createPlansPageUrl } from '../../../../../components/pages/Plans/createPlansPageUrl'

export const PLANS_UPGRADE_DIALOG_CONFIG: PlanTileType[] = [
  {
    planName: PlanLabel.PRO,
    header: 'PlansUpgradeDialog.ProTileHeader',
    subheader: 'PlansUpgradeDialog.ProTileSubheader',
    href: FLOWCODE_MARKETING_BASE_URL + '/pro'
  },
  {
    planName: PlanLabel.PRO_PLUS,
    header: 'PlansUpgradeDialog.ProPlusTileHeader',
    subheader: 'PlansUpgradeDialog.ProPlusTileSubheader',
    href: FLOWCODE_MARKETING_BASE_URL + '/proplus'
  },
  {
    planName: PlanLabel.ENTERPRISE,
    header: 'PlansUpgradeDialog.EnterpriseTileHeader',
    subheader: 'PlansUpgradeDialog.EnterpriseTileSubheader',
    href: FLOWCODE_MARKETING_BASE_URL + '/enterprise'
  }
]

export const COMPARE_ALL_PLANS_TILE_CONFIG: PlanTileType = {
  planName: PlanLabel.COMPARE,
  header: 'PlansUpgradeDialog.CompareAllPlansTileHeader',
  subheader: 'PlansUpgradeDialog.CompareAllPlansTileSubheader',
  href: createPlansPageUrl().toString()
}
